import "./ProfileDetail.css"
import config from "../Config/Config.json";

function ProfileDetail({ scrollToProjects, scrollToContact }) {

    const mList = ["Resume", "Projects", "Contact"];
    const mColorList = ["#eea302ff", "#ff3b25ff", "#80d8daff"];
    //     const mList = ["Resume", "Contact"];
    // const mColorList = ["#eea302ff", "#80d8daff"];
    
    const handleButtonClick = (type) => {
    if (type === "Resume" && config?.resume_link) {
      const link = document.createElement("a");
      link.href = config.resume_link; // path from config
      const fileName = config.resume_link.split("/").pop() || "Resume.pdf";
      link.download = fileName;
      link.click();
    } else if (type === "Contact") {
      scrollToContact?.(); // safely call if provided
    } else if(type === "Projects") {
        scrollToProjects?.();
    }
  };

  return (<div className="profile-detail">
    <img className="profile-photo" alt="Profile" src={config.profile_logo} />
    <div className="profile-details">
        <h1 className="profile-heading">Hello</h1>
        <div className="profile-title">A Bit About Me</div>
        <div className="profile-subtitle">{config.profile_summary}</div>
        <div className="profile-options">
            {mList.map((items, index) => 
                <div className="profile-options-circle" onClick={() => handleButtonClick(items)} style={{backgroundColor: mColorList[index] || "#fff"}}>
                    <span>{items}</span>
                </div>
            )}
        </div>
    </div>
  </div>);
}
export default ProfileDetail;